import {Button, Card, CardContent, Stack, Typography} from "@mui/material";
import {useAuth} from "../../store/AuthProvider";
import LowPriorityIcon from '@mui/icons-material/LowPriority';
import LocalPizzaIcon from '@mui/icons-material/LocalPizza';
import CategoryIcon from '@mui/icons-material/Category';
import {Link} from "react-router-dom";

const actionButtons = [
    {
        title: 'Modifica Categorie',
        link: '/admin/categorie',
        icon: <CategoryIcon sx={{fontSize: '2rem'}} />
    }, {
        title: 'Modifica Prodotti',
        link: '/admin/prodotti',
        icon: <LocalPizzaIcon sx={{fontSize: '2rem'}} />
    }, {
        title: 'Ordina Menu',
        link: '/admin/ordina-menu',
        icon: <LowPriorityIcon sx={{fontSize: '2rem'}} />
    }

];

const AdminHomePage = () => {
    const auth = useAuth();

    return <>
        <Card sx={{maxWidth: '800px', mb:3}}>
            <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                    Ciao {auth.user.name}!
                </Typography>
                <Typography  variant="body1" color="text.secondary">
                    Benvenuto nell'area admin di labruschettasupersano.it. Usando i pulsanti in basso (o nel menu a sinistra) puoi modificare i tuoi prodotti.
                </Typography>
            </CardContent>
        </Card>
        <Card sx={{maxWidth: '800px'}}>
            <CardContent>
                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={{ xs: 2, md: 2 }}
                    useFlexGap
                    flexWrap="wrap"
                    justifyContent="center"
                    alignItems="center"
                >
                    {actionButtons.map(ab =>{
                        return <Link to={ab.link} key={ab.title} style={{textDecoration: 'none', color: 'initial'}}>
                            <Button
                                variant='contained'
                                sx={{
                                    flexGrow: 1,
                                    height: '160px',
                                    width: '160px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '10px',
                                    padding: '20px'
                                }}>
                                {ab.icon}
                                <Typography variant='h7'>
                                    {ab.title}
                                </Typography>
                            </Button>
                        </Link>;
                    })}
                </Stack>
            </CardContent>
        </Card>
    </>
}

export default AdminHomePage;